import Table from "../table"
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Tooltip, Typography,DialogTitle,Dialog,TextField,Button,Box} from "@mui/material"
import Modal from '@mui/material/Modal';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { orderUpdateSlip, getBatchOrders } from "../../services/orders"
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PrintIcon from '@mui/icons-material/Print';
import ForwardIcon from '@mui/icons-material/Forward';
import QRCode from "react-qr-code";
import moment from "moment"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const user_id = localStorage.getItem('user_id')
const role_id = localStorage.getItem('role_id')
const config = require('../../config')

const API_URL = config.API_URL
const ROOT = config.ROOT

const token = localStorage.getItem('accessToken')

const HistoryTable = ({ rows }) => {
    const [open_slip, setOpenslip] = useState(false)
    const [img, setIMG] = useState(null)
    const [img_upload, setIMGUpload] = useState('')
    const [order_id, setOrderId] = useState('')
    const [confirm_payment, setConfirmPayment] = useState('')
    const [selectedFile, setSelectedFile] = useState(null)
    const [qrcode_detail, setQRDetail] = useState('')
    const [show_qrcode, setShowQrCode] = useState(false)
    const [list_detail, setListDetail] = useState([])
    const [open, setOpen] = useState(false)
    const [remark, setRemark] = useState('')
    const printRef = useRef();
    const columns = [
        { field: 'orders_no', headerName: 'เลขคำสั่งซื้อ', width: 150, align: 'center' },
        // { field: 'orderer', headerName: 'ผู้สั่ง', width: 300, align: 'center' },
        {
            field: 'orderer', headerName: role_id == 2 ? 'หัวจุด' : 'เกษตรกร', width: 300, align: 'center',
        },
        { field: 'order_date', headerName: 'วันที่สั่ง', width: 200, align: 'center' },
        { field: 'status', headerName: 'สถานะ', width: 100, align: 'center' },
        {
            field: "remark",
            headerName: "หมายเหตุ",
            width: 120,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>หมายเหตุ</Typography>} >
                    <IconButton color="primary" onClick={() => handleOpenDialog(params.row.remark)}>
                        <InfoOutlinedIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        },
        { field: 'product', headerName: 'สินค้า / SKU', width: 300, align: 'center' ,
        renderCell: (params) => (
            <Tooltip title={params.value} arrow>
              <Typography noWrap>{params.value}</Typography>
            </Tooltip>
          )
        },
  
        {
            field: 'quantity',
            headerName: 'น้ำหนัก (kgs)',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            valueFormatter: (params) => {
                const value = Number(params.value);
                return isNaN(value)
                    ? ''
                    : value.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    });
            },
        },

        { field: 'delivery_date', headerName: 'วันที่ส่งมอบ', width: 200, align: 'center' },
        {
            field: "detail",
            headerName: "รายละเอียด",
            width: 150,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>รายละเอียด</Typography>} >
                    <IconButton color="primary" onClick={() => { window.location.href = 'history/' + params.row.id }}>
                        <SearchIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        },

    ]
    if (role_id !== '3') {
        columns.push({
            field: "slip",
            headerName: "อัพโหลดslip",
            width: 150,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>อัพโหลดslip</Typography>} >
                    <IconButton color="primary" onClick={() => showSlip(params.row)}>
                        <FileUploadIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        });
    }
    if (role_id == '2') {
        columns.push({
            field: "pay_farmer",
            headerName: "การจ่ายเงินเกษตรกร",
            width: 300,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>การจ่ายเงินเกษตรกร</Typography>} >
                    <IconButton color="primary" onClick={() => window.location.href = 'payment/' + params.row.id}>
                        <LocalAtmIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        }, {
            field: "qrpallet",
            headerName: "QR Code Pallet",
            width: 200,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>QR Code Pallet</Typography>} >
                    <IconButton color="primary" onClick={() => showQrcode(params.row)}>
                        <PrintIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        },
            {
                field: "qr2",
                headerName: "QR Code กรอกค่าสาร",
                width: 200,
                align: 'center',
                renderCell: (params) => (
                    <Tooltip title={<Typography>QR Code กรอกค่าสาร</Typography>} >
                        <IconButton color="primary" onClick={() => { window.location.href = 'qrcode/' + params.row.id }}>
                            <ForwardIcon sx={{ color: '#15322D', fontSize: 40 }} />
                        </IconButton>
                    </Tooltip>
                ),
            });
    }
    const showQrcode = async (row) => {
        let res = await getBatchOrders({ order_id: row.id, role_id: role_id }, token)
        let detail = res.data.data  
        // const merged = {};
        // for (const item of detail) {
        // const key = item.farmers?.[0]?.create_by;
        // if (!key) continue;
        
        // if (!merged[key]) {
        // merged[key] = { ...item }; // ใช้ item ปัจจุบันเป็น default
        // } else {
        // merged[key].quantity += item.quantity;
        // // ข้อมูลอื่นๆ ใช้ของล่าสุด (item ปัจจุบัน)
        // merged[key] = { ...item, quantity: merged[key].quantity };
        // }
        // }
        
        // const mergedDetails = Object.values(merged);  
        console.log(detail)   
        setListDetail(detail)
        setQRDetail(row)
        setShowQrCode(true)
        setOrderId(row.id)
    }
    const showSlip = (row) => {
        setIMG(row.img_slip)
        setOrderId(row.id)
        setConfirmPayment(row.confirm_payment)
        setOpenslip(true)
    }
    const update = (url) => {

        orderUpdateSlip({
            user_id: user_id,
            img_slip: url,
            order_id: order_id
        }, token)
            .then((res) => {
                window.location.reload();
                setOpenslip(true)
            }).catch(error => {
                console.log(error)
            })
    }

    const style_assign = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const handleOpenDialog = (remark) => {
        setRemark(remark)
        setOpen(true)
    }
    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const printWindow = window.open("", "", "width=800,height=600");
        printWindow.document.write(`
            <html>
            <head>
                <style>
                    @page {
                        size: 100mm 150mm;
                        margin: 0;
                    }
                    html, body {
                        margin: 0;
                        padding: 0;
                        width: 100%;
                        height: 100%;
                        font-family: 'Arial', sans-serif;
                    }
                    body {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .print-area {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        box-sizing: border-box;
                        text-align: center;
                        padding: 0; /* เอา padding ออกเพื่อให้กลางจริง */
                    }
                    .qr {
                        margin-bottom: 12px;
                    }
                    b {
                        font-weight: bold;
                    }
                    p {
                        margin: 2px 0;
                        font-size: 14px;
                    }
                </style>
            </head>
            <body>
                <div class="print-area">
                    ${printContents}
                </div>
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };



    return (
        <div style={{ height: 600, width: "100%" }}>
            <Modal
                open={open_slip}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 2 }}
            >
                <Box sx={style_assign}>
                    <IconButton
                        style={{ position: "absolute", top: "0", right: "0" }}
                        onClick={() => setOpenslip(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                    <h3>อัพโหลดหลักฐานการโอนเงิน</h3>
                    {img ? (
                        <img
                            src={img}
                            alt="หลักฐานการโอนเงิน"
                            style={{ width: "100%", height: "auto", marginTop: "20px" }}
                        />


                    ) : (
                        <> <input
                            type="file"
                            accept="image/*"
                            onChange={(event) => {
                                const file = event.target.files?.[0];
                                if (file) {
                                    setSelectedFile(file); // เก็บไฟล์ใน state
                                }
                            }}
                            style={{ marginTop: "20px" }} /><Button
                                variant="contained"
                                style={{
                                    marginTop: "20px",
                                    float: "right", // ปุ่มชิดขวา
                                }}
                                onClick={async () => {
                                    if (!selectedFile) {
                                        alert("กรุณาเลือกไฟล์ก่อน");
                                        return;
                                    }

                                    const formData = new FormData();
                                    formData.append("files", selectedFile);
                                    formData.append("type", 'slip');
                                    formData.append("order_id", order_id);

                                    try {
                                        const response = await fetch(API_URL + "/upload", {
                                            method: "POST",
                                            headers: { 'Authorization': `Bearer ${token}` },
                                            body: formData,
                                        });
                                        console.log(response)
                                        if (response.status) {
                                            console.log(response)
                                            alert("อัพโหลดไฟล์สำเร็จ");
                                            const result = await response.json();
                                            setIMGUpload(result.url);
                                            update(result.url)
                                        } else {
                                            alert("การอัพโหลดล้มเหลว");
                                        }
                                    } catch (error) {
                                        console.error("เกิดข้อผิดพลาด:", error);
                                        alert("เกิดข้อผิดพลาดในการอัพโหลดไฟล์");
                                    }
                                }}
                            >
                                อัพโหลดไฟล์
                            </Button></>
                    )}
                    {confirm_payment == 1 ? (
                        <p style={{ marginTop: "20px", color: "green", fontWeight: "bold" }}>
                            ยืนยันการรับเงินแล้ว
                        </p>
                    ) : (
                        <p style={{ marginTop: "20px", color: "red", fontWeight: "bold" }}>
                            ยังไม่ได้ยืนยันการรับเงิน
                        </p>
                    )}
                </Box>
            </Modal>
            <Modal
                open={show_qrcode}
                onClose={() => setShowQrCode(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 2 }}
            >
                <Box sx={style_assign}>
                    <IconButton
                        style={{ position: "absolute", top: 8, right: 8 }}
                        onClick={() => setShowQrCode(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* QR Code */}
                    <Box ref={printRef}>
                        <Box display="flex" justifyContent="center" mb={2}>
                            <QRCode value={ROOT + "/substance/pallet/" + order_id} size={128} />
                        </Box>

                        {/* รายละเอียด */}
                        <Typography><b>Lot No.  :  </b>{qrcode_detail.lot_no}</Typography>
                        <Typography><b>น้ำหนักสุทธิ  :  </b>{Number(qrcode_detail.quantity).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}</Typography>
                        <Typography>
                            <b>No. of Farmer : </b>{list_detail.length ?? 0}
                        </Typography>
                        <Typography><b>ID FARMER :</b></Typography>
                        {list_detail?.map((list, index) => (

                            <Typography key={index}>
                                {list.farmers[0].tag_user_id} = {Number(list.quantity).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })} kgs
                            </Typography>
                        ))}
                        <Typography><b>วันที่-เวลาเข้า:  </b>{moment(qrcode_detail.delivery_date).format('DD-MM-YYYY')}</Typography>
                    </Box>

                    {/* ปุ่มพิมพ์ */}
                    <Box display="flex" justifyContent="center" mt={3}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#f2f2f2",
                                color: "#000",
                                fontWeight: "bold",
                                borderRadius: "12px",
                                px: 4,
                            }}
                            onClick={handlePrint}
                        >
                            Print QR CODE
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Table
                rows={rows}
                columns={columns}
            />
             <Dialog open={open} onClose={handleCloseDialog} fullWidth>
                <DialogTitle sx={{ justifyContent: 'center', display: 'flex', fontSize: '24px' }}>หมายเหตุ</DialogTitle>
                <TextField
                    sx={{ padding: 4 }}
                    variant="outlined"
                    value={remark}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <div style={{ paddingBottom: 3, justifyContent: 'center', display: 'flex' }}>
                    <Button
                        onClick={handleCloseDialog}
                        variant="contained"
                        sx={{
                            px: 4,
                            backgroundColor: '#C9D4C4',
                            color: '#15322D',
                            fontSize: '20px',
                            '&:hover': {
                                backgroundColor: '#A2B29F',
                            },
                        }}
                    >
                        ย้อนกลับ
                    </Button>
                </div>
            </Dialog>
        </div>
    )
}

export default HistoryTable